angular.module('myApp.aboutUs', ['ngRoute'])

    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/aboutus', {
            templateUrl: 'components/aboutUs/aboutUs.html',
            controller: 'aboutUsCtrl'
        })
    }])
        .controller('aboutUsCtrl', ['$scope','$window', '$timeout',function( $scope, $window,$timeout) {
            $window.scrollTo(0, 0);
            $("#menu").css({'border-bottom':'0px solid  #595968', 'padding-bottom':'3px'});
            $("#fatafat").css({'border-bottom':'0px solid  #595968', 'padding-bottom':'3px'});
            $("#meals").css({'border-bottom':'0px solid  #595968', 'padding-bottom':'3px'});
            $("#delivery").css({'border-bottom':'0px solid  #595968', 'padding-bottom':'3px'});
            $("#feed").css({'border-bottom':'0px solid  #595968', 'padding-bottom':'3px'});
            $("#rides").css({'border-bottom':'0px solid  #595968', 'padding-bottom':'3px'});
        }]);

